var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{staticClass:"user-profile-picture",style:(_vm.userProfileStyle)},[_vm._v("\n\t"+_vm._s(_vm.placeholderPicture)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }